import { gql } from '@apollo/client';

/**
 * dynamically generates a query containing the specified fields from the descriptor,
 * when applying it with apollo, use with fetchPolicy: 'no-cache' to avoid cache weird behaviour
 */
export function generateEnrichedQuery(fields: { key: string; path: string }[]) {
  const fieldSelections = fields
    .map(field => {
      const alias = field.key;
      return `${alias}: descriptor(path: "${field.path}")`;
    })
    .join('\n');

  const queryString = `
      query getEnrichedDataById($ids: [bigint!]) {
        dataProductInstance: marketplace_instances( where: {id: {_in: $ids}}) {
          entityId:id
          ${fieldSelections}
        }
      }
    `;

  return gql(queryString);
}
